import { PricingStrategy } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box, Heading, SkeletonRectangle, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { clsx } from 'clsx';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsHarmonyTheme } from '@wix/core-domain-search';
import { usePerceptionTldRow } from '../../pricingPerception';
import { PerceptionTldPrice } from './PerceptionTldPrice';
import s from './tldPromotionBoxes.scss';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
const AI_TLD_TOOLTIP_KEY = 'domains-search-suite-translations-ns:domain_search_suite.tld_section.ai_tooltip.text';
export const TldPromotionBox = _ref => {
  var _perceptionRow$note;
  let {
    tld,
    description,
    pricing,
    onClick
  } = _ref;
  const {
    t: tSuite
  } = DomainSearchSuiteModule.internals.useTranslations();
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const perceptionRow = usePerceptionTldRow(pricing, tld);
  const isHarmonyTheme = useIsHarmonyTheme();
  const showFreeWithPlanBadge = (pricing == null ? void 0 : pricing.pricingStrategy) === PricingStrategy.FREE_FIRST_YEAR;
  const showAIDisclaimer = tld === 'ai' && (pricing == null ? void 0 : pricing.pricingStrategy) === PricingStrategy.MULTI_YEAR_MINIMUM_COUNT;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(s.card, isHarmonyTheme && s.cardHarmony),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Box, {
    minHeight: "18px"
  }, ((perceptionRow == null ? void 0 : perceptionRow.note) || showFreeWithPlanBadge) && /*#__PURE__*/React.createElement(Box, {
    padding: "3px 6px",
    width: "max-content",
    backgroundColor: "#DFF994",
    borderRadius: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    className: s.badgeText
  }, tSuite((perceptionRow == null || (_perceptionRow$note = perceptionRow.note) == null ? void 0 : _perceptionRow$note.labelKey) ?? 'domain_search_suite.domain_gate.tld_section.badge.free_with_plan')))), /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: s.tld
  }, ".", tld), description && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true,
    className: s.description
  }, description), (pricing == null ? void 0 : pricing.price) && perceptionRow && /*#__PURE__*/React.createElement(PerceptionTldPrice, {
    pricing: pricing,
    row: perceptionRow
  }), (pricing == null ? void 0 : pricing.price) && !perceptionRow && /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    verticalAlign: "middle",
    className: s.price,
    marginTop: "auto"
  }, pricing.originalPrice && /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true,
    className: s.strikethroughPrice
  }, t('domain_search_gate.domain_gate.tld_section.domain_price', {
    domainPrice: pricing.originalPrice
  })), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, t('domain_search_gate.domain_gate.tld_section.domain_price', {
    domainPrice: pricing.price
  })), showAIDisclaimer && /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(Box, {
      padding: "SP3 SP4"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin",
      light: true
    }, t(AI_TLD_TOOLTIP_KEY)))
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon
  })))));
};
export const TldPromotionBoxSkeleton = () => {
  const isHarmonyTheme = useIsHarmonyTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(s.card, isHarmonyTheme && s.cardHarmony)
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "133px",
    height: "18px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "120px",
    height: "40px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "100%",
    height: "38px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "148px",
    height: "20px"
  }));
};
//# sourceMappingURL=TldPromotionBox.js.map